import { MapWithDefault } from '@shipit/shared/core/util';

enum GetStoresQueryParam {
    CONTACT_ID = 'contactId',
    STORE_CODE = 'storeCode',
    COUNTRY_CODE = 'countryCode',
    PAGE = 'page',
    LIMIT = 'limit',
    SORT = 'sort',
    IS_ASCENDING = 'isAscending'
}

enum GetStoresSortingColumn {
    CONTACT_ID = 'contactId',
    STORE_CODE = 'storeCode',
    NAME1 = 'name1',
    NAME2 = 'name2',
    NAME3 = 'name3',
    STREET = 'street',
    STREET_NO = 'streetNo',
    ZIP_CODE = 'zipCode',
    CITY = 'city',
    COUNTRY_CODE = 'countryCode',
    PHONE = 'phone',
    MOBILE = 'mobile',
    MAIL = 'mail',
    CONTACT_PERSON = 'contactPerson'
}

const GET_STORES_SORTING_COLUMNS: GetStoresSortingColumn[] = Object.values(GetStoresSortingColumn);

const GET_STORES_SORTING_COLUMNS_TRANSLATION_KEYS: MapWithDefault<string, string> = new MapWithDefault<string, string>(
    (column: string): string => `global.labels.${column}`,
    [
        [GetStoresSortingColumn.STREET_NO, 'global.labels.streetNumber'],
        [GetStoresSortingColumn.COUNTRY_CODE, 'global.labels.country'],
        [GetStoresSortingColumn.MAIL, 'global.labels.email']
    ]
);

export { GetStoresQueryParam, GetStoresSortingColumn, GET_STORES_SORTING_COLUMNS, GET_STORES_SORTING_COLUMNS_TRANSLATION_KEYS };
